module.exports = __webpack_public_path__ + "pathetic.c509e626.png";